import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  public pendingSessionChanges = new BehaviorSubject<boolean>(false);

  constructor() { }
}
